import { SERVER_URL } from "./config";

const groupNames = ["group-1"];

function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2)
      month = '0' + month;
  if (day.length < 2)
      day = '0' + day;

  return [year, month, day].join('-');
}

const paymentStatementDataObject = {
  statement_no: "",
  bilty_ids: [],
  bilty_info_list: [],
  statement_date: formatDate(new Date()),
  created_from: "",
  created_by: "",
  total_amount: "",
  id: "",
};

const paymentStatementGroupInfo = {
  "group-1": [
    {
      label: "Statement No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "statement_no",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "bilty_no_input",
      },
      toValidate: false,
    },
    {
      label: "Statement Date",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "statement_date",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "save_button",
      },
      toValidate: false,
    },
  ],
};

function validate(values) {
  let errors = {};
  return errors;
}

export {
  paymentStatementGroupInfo,
  groupNames,
  paymentStatementDataObject,
  validate,
};
